/****************************************************
 * Module Name:  boxProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class BoxProxy {
    static GetAllBoxesByLocation = (locationids, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/box/bylocations",
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(locationids),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetSingleBox = (boxId, callback) => {
        let params = {
            id: boxId,
        };

        restAPICall(
            Constants.MANAGER_URL + "/box",
            "get",
            Constants.userToken,
            params,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };


    static AddBox = (box, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/box",
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(box),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static UpdateBox = (box, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/box",
            "put",
            Constants.userToken,
            undefined,
            JSON.stringify(box),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static DeleteBox = (boxId, callback) => {
        let params = {
            id: boxId,
        };

        restAPICall(
            Constants.MANAGER_URL + "/box",
            "delete",
            Constants.userToken,
            params,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetAllStoneInBoxByLocationId = (locationid, data, callback) => {
        let params = {
            locationid: locationid,
        };

        restAPICall(
            Constants.MANAGER_URL + "/stonetally/box",
            "post",
            Constants.userToken,
            params,
            JSON.stringify(data),
            "application/json",
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetAllStoneWithoutBoxByLocationId = (locationid, data, callback) => {
        let params = {
            locationid: locationid,
        };

        restAPICall(
            Constants.MANAGER_URL + "/stonetally/withoutbox",
            "post",
            Constants.userToken,
            params,
            JSON.stringify(data),
            "application/json",
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static UpdateBoxIdForStone = (boxid, data, callback) => {
        let params = {
            boxid: boxid,
        };

        restAPICall(
            Constants.MANAGER_URL + "/stonetally/box",
            "put",
            Constants.userToken,
            params,
            JSON.stringify(data),
            "application/json",
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

}
